const common = {
  MAX_NODE_LENGTH: 5,
  DEFAULT_TEMPLATE_EXPIRED_DAY: 7,
  DEFAULT_TRIP_RANGE: 14,
  UPLOAD_IMAGE_FILE_SIZE_LIMIT_BYTES: 5000000,
  UPLOAD_AUDIO_FILE_SIZE_LIMIT_BYTES: 20000000,
  UPLOAD_VIDEO_FILE_SIZE_LIMIT_BYTES: 20000000,
  MAX_CARD_TITLE_LENGTH: 40,
  MAX_CARD_SUBTITLE_LENGTH: 60,
  MAX_BUTTON_TITLE_LENGTH: 20,
  SESSION_TOKEN_NAME: 'ec_parseSessionToken',
  PARSE_JAVASCRIPT_KEY: 'javascriptKey',
  DEFAULT_LOGO_IMAGE_URL: 'https://assets.no8.io/img_linkmember_logo.png',
  ADDON_UNAVAIABLE_MAIL: 'sales@no8.io',
  DEBOUNCE_DELAY: 600,
  APP_TITLE: 'SUPER 8 Studio',
};

const dev = {
  ENDPOINT: 'https://stage-supermarket.no8.io',
  PARSE_SERVER_URL: 'https://stage-api-live-query.no8.io',
  PARSE_APP_ID: 'number8_stage',
  SERVER_URL: 'https://stage-api-next.no8.io',
  SHORT_SERVER_URL: 'https://tn.no8.io',
  UPLOAD_URL: 'https://t.no8.io/uploader/files',
  META_TAG_CRAWLER_URL: 'https://t.no8.io/crawl',
  NOT_NEXT_BROADCAST_QUICK_REPLY: [],
  NOT_USED_JOINED_ORGANIZATION_LIST: [],
  PARTNER_TAG_SERVER_URL: 'https://t.no8.io',
  CONSOLE_URL: 'https://stage-console.no8.io',
  GAME_API_URL: 'https://t.no8.io/game-module-api',
  AIBOT_SOCKET_SERVER_URL: 'wss://stage-ws.no8.io',
};

const prod = {
  ENDPOINT: 'https://supermarket.no8.io',
  PARSE_SERVER_URL: 'https://prod-api-lq.no8.io',
  PARSE_APP_ID: 'number8',
  SERVER_URL: 'https://api-next.no8.io',
  SHORT_SERVER_URL: 'https://nn.no8.io',
  UPLOAD_URL: 'https://n.no8.io/uploader/files',
  META_TAG_CRAWLER_URL: 'https://n.no8.io/crawl',
  NOT_NEXT_BROADCAST_QUICK_REPLY: ['cJOr2AwKTx'],
  NOT_USED_JOINED_ORGANIZATION_LIST: ['YHBVTH4G9j'],
  PARTNER_TAG_SERVER_URL: 'https://n.no8.io',
  CONSOLE_URL: 'https://console.no8.io',
  GAME_API_URL: 'https://n.no8.io/game-module-api',
  AIBOT_SOCKET_SERVER_URL: 'wss://ws.no8.io',
};

const config =
  process.env.REACT_APP_STAGE === 'production'
    ? { ...common, ...prod }
    : { ...common, ...dev };

export default config;
